import { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import PageLayout from "components/layout/page-layout";
import ActionButton from "components/table/action-btn";
import Table, { tableHeader } from "components/table";
import { oneLine, tagsList } from "components/table/table-parts";
import { IconTrash } from "@tabler/icons-react";
import { useSharedState } from "state";
import DangerModal from "components/modal/danger";

export default function Codes() {
  const { codes, getCodesData, notify } = useSharedState();

  const navigate = useNavigate();

  const [codeToBlock, setCodeToBlock] = useState<number>(0);
  const [isFormLoading, setFormLoading] = useState<boolean>(false);

  const deleteDanger = "Вы действительно хотите изменить статус кода ИТ?";

  useEffect(() => {
    getCodesData();
  }, []);

  const onCodeBlock = async () => {
    setFormLoading(true);

    try {
      // block
      notify("Код ИТ изменён", "success");

      await getCodesData();
    } catch (error: any) {
      let err = JSON.stringify(error?.response?.data?.detail);
      notify(err, "danger", "Ошибка при изменении кода ИТ");
    } finally {
      setFormLoading(false);
      setCodeToBlock(0);
    }
  };

  const codesTableHeaders: tableHeader[] = [
    { header_text: "Название кода ИТ", narrow: false, wrap: false },
    // { header_text: "Действия", narrow: false, wrap: false },
  ];

  const codesList = (
    <>
      {codes.map((code, index) => (
        <tr key={index}>
          <td>{oneLine(code.code_it)}</td>
          {/* <td>
            <div className="btn-list flex-nowrap">
              <ActionButton
                icon={<IconTrash className="icon" />}
                title="Удалить"
                action={() => setCodeToDelete(code.id)}
                color={"info"}
                modal={true}
                modal_id="#modal-delete-code"
              />
            </div>
          </td> */}
        </tr>
      ))}
    </>
  );

  const codesTable = Table(codesTableHeaders, codesList, false);

  return (
    <>
      <PageLayout
        children={codesTable}
        header={"Коды ИТ"}
        subheaderText={`Количество кодов ИТ: ${0}`}
        search={false}
        filters={false}
        sorters={false}
        buttonText={"Новый код ИТ"}
        buttonAction={() => navigate("create")}
      />
      <DangerModal
        modal_id="modal-delete-code"
        dangerDescription={deleteDanger}
        cancel={() => setCodeToBlock(0)}
        confirm={onCodeBlock}
      />
      <Outlet />
    </>
  );
}
